module.exports = __webpack_public_path__ + "img/icon-warning-generic-3.164e1664.svg";